import React, { useEffect, useState } from 'react';
import { ReactComponent as Selected } from '../../../assets/icons/Radiobutton-s.svg';
import { ReactComponent as NotSelected } from '../../../assets/icons/Radiobutton-n.svg';
import TextInput from '../../BaseComponents/TextInput';
import { useFormikContext } from 'formik';
import { OnboardingFormValues } from '../../../types/membersTypes';
import './FormQuestion.scss';

type Answer = 'yes' | 'no';

type YesNoDescribeQuestionProps = {
  title: string;
  answerField: keyof OnboardingFormValues;
  detailField: keyof OnboardingFormValues;
  detailPlaceholder?: string;
};

const YesNoDescribeQuestion: React.FC<YesNoDescribeQuestionProps> = ({
  title,
  answerField,
  detailField,
  detailPlaceholder = 'If yes, please describe:'
}) => {
  const { values, errors, setFieldValue, setFieldError } =
    useFormikContext<OnboardingFormValues>();

  const formAnswer = values[answerField];
  const detailValue = (values[detailField] as string) || '';
  const answerError = errors[answerField] as string | undefined;
  const detailError = errors[detailField] as string | undefined;

  const [selected, setSelected] = useState<Answer | undefined>(
    formAnswer === 'yes' || formAnswer === 'no' ? formAnswer : undefined
  );

  useEffect(() => {
    if (formAnswer === 'yes' || formAnswer === 'no') {
      setSelected(formAnswer);
    }
  }, [formAnswer]);

  const onAnswerChange = (answer: Answer) => {
    setSelected(answer);
    setFieldValue(answerField as string, answer);
    setFieldError(answerField as string, undefined);

    if (answer === 'no') {
      setFieldValue(detailField as string, '');
      setFieldError(detailField as string, undefined);
    }
  };

  return (
    <div className='form-question-container'>
      <div className='section-header'>{title} *</div>
      <div className='answers'>
        <div className='yes-no'>
          <div
            className={`answer yes ${selected === 'yes' ? 'answer-active' : ''}`}
            onClick={() => onAnswerChange('yes')}
          >
            Yes
            {selected === 'yes' ? <Selected /> : <NotSelected />}
          </div>
          <div
            className={`answer no ${selected === 'no' ? 'answer-active' : ''}`}
            onClick={() => onAnswerChange('no')}
          >
            No
            {selected === 'no' ? <Selected /> : <NotSelected />}
          </div>
        </div>
      </div>
      {answerError && <div className='error-message'>{answerError}</div>}
      {selected === 'yes' && (
        <div className='supplements-selection'>
          <TextInput
            title='If yes, please describe: *'
            name={detailField as string}
            id={`${String(detailField)}_text_input`}
            placeholder={detailPlaceholder}
            type='text'
            value={detailValue}
            isError={!!detailError}
            errorMessage={detailError}
            onChange={(e) => {
              setFieldValue(detailField as string, e.target.value);
              setFieldError(detailField as string, undefined);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default YesNoDescribeQuestion;
